module.exports = {"privacyLink":"https://www.totaljobs.com/privacy-policy","cookieLink":"https://www.totaljobs.com/cookies"}